// Imports
import { Content, Container, ComponentWrapper, Img } from "@/components";

// Text With Image
export function TextWithImage({
  type,
  content,
  imageAlignment,
  image,
  orientation,
}) {
  // Aspect Ratio
  const aspectRatio = () => {
    switch (orientation) {
      case "landscape":
        return "aspect-landscape";
      case "portrait":
        return "aspect-portrait";
      case "square":
        return "aspect-square";
      default:
        return "aspect-landscape";
    }
  };

  // Alignment
  const alignment = () => {
    switch (imageAlignment?.value) {
      case "left":
        return "order-first";
      case "right":
        return "order-last";
    }
  };

  // Render
  return (
    <ComponentWrapper type={type}>
      <Container>
        <div className="flex flex-col gap-5 lg:flex-row lg:gap-20">
          <div className={`${alignment()} w-full basis-1/2`}>
            <div
              className={`${aspectRatio()} relative w-full overflow-hidden rounded-base`}
            >
              <Img data={image} sizes="(max-width: 1024px) 100vw, 800px" fill />
            </div>
          </div>
          <div className="basis-1/2">
            <Content className="w-full" content={content} />
          </div>
        </div>
      </Container>
    </ComponentWrapper>
  );
}
